/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateProductDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivProductControllerGetParamsGen,
  MrfiktivProductViewModelGen,
  MrfiktivUpdateProductDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Products<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags products
   * @name ProductControllerCreate
   * @summary (Product - CREATE) Create a product for a partner
   * @request POST:/partner/{partnerId}/product
   * @secure
   * @response `201` `MrfiktivProductViewModelGen` Operation was successful
   */
  productControllerCreate = (partnerId: string, data: MrfiktivCreateProductDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivProductViewModelGen, any>({
      path: `/partner/${partnerId}/product`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags products
   * @name ProductControllerGet
   * @summary (Product - READ) Get all products of a partner
   * @request GET:/partner/{partnerId}/product
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivProductViewModelGen)[] })`
   */
  productControllerGet = ({ partnerId, ...query }: MrfiktivProductControllerGetParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivProductViewModelGen[] }, any>({
      path: `/partner/${partnerId}/product`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags products
   * @name ProductControllerDeleteByProductId
   * @summary (Product - DELETE) Deactivates a product of a Partner
   * @request DELETE:/partner/{partnerId}/product/{productId}
   * @secure
   * @response `201` `MrfiktivProductViewModelGen` Operation was successful
   */
  productControllerDeleteByProductId = (partnerId: string, productId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivProductViewModelGen, any>({
      path: `/partner/${partnerId}/product/${productId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags products
   * @name ProductControllerGetById
   * @summary (Product - READ) Retrieve a product of a partner
   * @request GET:/partner/{partnerId}/product/{productId}
   * @secure
   * @response `201` `MrfiktivProductViewModelGen` Operation was successful
   */
  productControllerGetById = (partnerId: string, productId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivProductViewModelGen, any>({
      path: `/partner/${partnerId}/product/${productId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags products
   * @name ProductControllerUpdate
   * @summary (Product - UPDATE) Updates a product
   * @request PATCH:/partner/{partnerId}/product/{productId}
   * @secure
   * @response `201` `MrfiktivProductViewModelGen` The updated product
   */
  productControllerUpdate = (
    partnerId: string,
    productId: string,
    data: MrfiktivUpdateProductDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivProductViewModelGen, any>({
      path: `/partner/${partnerId}/product/${productId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
